import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '@/utils/api'

// Async thunks
export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await api.post('/login', credentials)
      localStorage.setItem('token', response.data.token)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const selectVerificationMethod = createAsyncThunk(
  'auth/selectVerificationMethod',
  async (method, { rejectWithValue }) => {
    try {
      const response = await api.post('/select-verification-method', { method });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const verifyAccount = createAsyncThunk(
  'auth/verifyAccount',
  async (code, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-account', { code });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const resendVerificationCode = createAsyncThunk(
  'auth/resendVerificationCode',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.post('/resend-verification-code');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const requestVerification = createAsyncThunk(
  'auth/requestVerification',
  async (emailOrPhone, { rejectWithValue }) => {
    try {
      const response = await api.post('/request-verification', { email_or_phone: emailOrPhone });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const requestTwoVerification = createAsyncThunk(
  'auth/requestTwoVerification',
  async (emailOrPhone, { rejectWithValue }) => {
    try {
      const response = await api.post('/request-two-verification', { email_or_phone: emailOrPhone });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const requestEmailOtp = createAsyncThunk(
  'auth/requestEmailOtp',
  async (email, { rejectWithValue }) => {
    try {
      const response = await api.post('/request-email-otp', { email })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const requestSmsOtp = createAsyncThunk(
  'auth/requestSmsOtp',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post('/request-sms-otp', { ...data })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const forgotPassword = createAsyncThunk(
  'auth/forgotPassword',
  async ({ identifier }, { rejectWithValue }) => {
    try {
      const response = await api.post('/request-otp', { identifier })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const verifyForgotPasswordOtp = createAsyncThunk(
  'auth/verifyForgotPasswordOtp',
  async ({ identifier, otp }, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-otp', { identifier, otp })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ identifier, password, password_confirmation }, { rejectWithValue }) => {
    try {
      const response = await api.post('/reset-password', { identifier, password, password_confirmation })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post('/register', userData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const verifyEmail = createAsyncThunk(
  'auth/verifyEmail',
  async (code, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-email', { code })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const verifyEmailOtp = createAsyncThunk(
  'auth/verifyEmailOtp',
  async ({ email, otp }, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-email-otp', { email, otp })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const resendEmailOtp = createAsyncThunk(
  'auth/resendEmailOtp',
  async (email, { rejectWithValue }) => {
    try {
      const response = await api.post('/resend-email-otp', { email });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const resendSmsOtp = createAsyncThunk(
  'auth/resendSmsOtp',
  async (phone, { rejectWithValue }) => {
    try {
      const response = await api.post('/resend-sms-otp', { phone });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message });
    }
  }
);

export const verifyPhone = createAsyncThunk(
  'auth/verifyPhone',
  async (code, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-phone', { code })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const verifyPhoneOtp = createAsyncThunk(
  'auth/verifyPhoneOtp',
  async ({ phone, otp }, { rejectWithValue }) => {
    try {
      const response = await api.post('/verify-sms-otp', { phone, otp })
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const updateProfile = createAsyncThunk(
  'profile/update',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post('/profile/update', formData)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || { message: error.message })
    }
  }
)

export const fetchUser = createAsyncThunk(
  'auth/fetchUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/user')
      return response.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    token: localStorage.getItem('token'),
    isAuthenticated: false,
    loading: false,
    error: null,
    loginError: null,
    registerError: null,
  },
  reducers: {
    logout: (state) => {
      localStorage.removeItem('token')
      state.user = null
      state.token = null
      state.isAuthenticated = false
    },
    clearError: (state) => {
      state.error = null
      state.loginError = null
      state.registerError = null
    },
  },
  extraReducers: (builder) => {
    builder
      // Login
      .addCase(loginUser.pending, (state) => {
        state.loading = true
        state.error = null
        state.loginError = null
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload.user
        state.token = action.payload.token
        state.isAuthenticated = true
        state.loginError = null
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || 'Login failed'
        state.loginError = action.payload?.message
      })
      // Request Two Verification
      .addCase(requestTwoVerification.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(requestTwoVerification.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(requestTwoVerification.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to send verification code';
      })
      // Register
      .addCase(registerUser.pending, (state) => {
        state.loading = true
        state.error = null
        state.registerError = null
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload.user
        state.registerError = null
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || 'Registration failed'
        state.registerError = action.payload?.message
      })
      // Verify Email
      .addCase(verifyEmail.fulfilled, (state, action) => {
        state.user = action.payload.user
      })
      // Verify Phone
      .addCase(verifyPhone.fulfilled, (state, action) => {
        state.user = action.payload.user
      })
      // Fetch User
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.user = action.payload
        state.isAuthenticated = true
      })
      // Update Profile
      .addCase(updateProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(resendEmailOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(resendEmailOtp.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(resendEmailOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || 'Failed to resend email OTP';
      })
      .addCase(updateProfile.fulfilled, (state, action) => {
        state.loading = false
        state.user = action.payload?.user || action.payload || state.user
      })
      .addCase(updateProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload?.message || 'Profile update failed'
      })
      // Handle manual dispatches from component
      .addMatcher(
        (action) => action.type === 'auth/login/fulfilled',
        (state, action) => {
          state.loading = false
          state.user = action.payload.user
          state.token = action.payload.token
          state.isAuthenticated = true
          state.loginError = null
          state.error = null
        }
      )
      .addMatcher(
        (action) => action.type === 'auth/login/rejected',
        (state, action) => {
          state.loading = false
          state.error = action.payload?.message || 'Login failed'
          state.loginError = action.payload?.message
        }
      )
  },
})

export const { logout, clearError } = authSlice.actions
export default authSlice.reducer